import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('activityCardHeader');

    return {
        FRIDAY: t('friday'),
        MONDAY: t('monday'),
        SATURDAY: t('saturday'),
        SUNDAY: t('sunday'),
        THURSDAY: t('thursday'),
        TODAY: t('today'),
        TUESDAY: t('tuesday'),
        WEDNESDAY: t('wednesday')
    };
};

export default useTranslation;
